<div class="download-status">
  @if (downloadURL === 'success') {
    <p class="success-message">File downloaded successfully!</p>
  }
  @if (downloadURL === 'error') {
    <p class="error-message">Failed to download file. Please try again.</p>
  }
  @if (downloadURL === null) {
    <p class="loading-message">Preparing download...</p>
  }
</div>
